'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresScheduleItem = function () {
    function WinresScheduleItem() {
        _classCallCheck(this, WinresScheduleItem);
    }

    _createClass(WinresScheduleItem, [{
        key: '$onInit',
        value: function $onInit() {
            // init stuff here
        }
    }, {
        key: 'click',
        value: function click() {
            console.log('[WinresScheduleItem] Click:', this.date, this.destcode, this.prodcode);
            if (this.onClick) {
                this.onClick();
            } else {
                console.warn('[WinresScheduleItem] No on-click handler.');
            }
        }
    }]);

    return WinresScheduleItem;
}();

WinresScheduleItem.$inject = [];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'WinresScheduleItem';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('WinresScheduleItem', require('./winresScheduleItem.html'));
}]);

_module3.default.component('winresScheduleItem', {
    // Note: This component is currently so simple it doesn't need a controller.
    // The bindings below are accessed directly as $ctrl.foo and so on.
    templateUrl: getTemplate,
    controller: WinresScheduleItem,
    bindings: {
        destcode: '@',
        prodcode: '@',
        // Item image URL, e.g. "https://dummyimage.com/200x100/000/fff"
        image: '@',

        // Item title, e.g. "Husky safari" or "Guided shopping trip to Old Town"
        title: '@',

        // The time when this item takes place. A free-form string, e.g. "7:30 PM" or "High Noon"
        time: '@',

        // The date of the item. YYYY-MM-DD ex. 2019-04-01
        date: '@',

        // Url
        url: '@',

        // Day passed. Show gray item if true
        past: '@',

        // Capacity available
        available: '<',

        // Capacity
        capacity: '<',

        // Closing date
        closingdate: '@',

        // Event to fire when the item is clicked.
        onClick: '&'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresScheduleItem/winresScheduleItem.js
// module id = 487
// module chunks = 2